<template>
    <veui-dialog
        class="trusteeship-dialog"
        :overlay-class="isConfirm ? 'trusteeship-dialog-overlay' : 'trusteeship-dialog-overlay is-release'"
        :open="open"
        :closable="false"
        @update:open="onOpenChange"
    >
        <template #title>
            <div class="title">{{ isConfirm ? '托管服务授权' : '解除线索托管' }}</div>
            <div
                class="close-btn"
                @click="onOpenChange(false)"
            ></div>
        </template>
        <div class="ts-body">
            <div v-if="isConfirm" class="ts-lead">
                超管账号“<span class="ts-strong">{{ platformName || 'XXX' }}</span>”邀请您授权“<span
                    class="ts-strong"
                >线索托管</span>”服务
            </div>
            <!-- <div v-else class="ts-lead">
                超管账号“<span class="ts-strong">{{ platformName || 'XXX' }}</span>”托管线索中
            </div> -->
            <div class="ts-desc">{{ desc }}</div>
            <img
                v-if="isConfirm"
                class="ts-illus"
                :src="illusImg"
            />
        </div>
        <template #foot>
            <template v-if="isConfirm">
                <veui-button
                    class="ts-btn-minor"
                    :loading="rejectLoading"
                    :disabled="loading"
                    @click="$emit('reject')"
                >拒绝托管</veui-button>
                <veui-button
                    ui="primary"
                    :loading="loading"
                    :disabled="rejectLoading"
                    @click="$emit('agree')"
                >授权托管</veui-button>
            </template>
            <div v-else class="ts-foot">
                <veui-button
                    class="ts-btn ts-btn-minor"
                    :disabled="loading"
                    @click="$emit('dismiss')"
                >暂不</veui-button>
                <veui-button
                    class="ts-btn ts-btn-primary"
                    ui="primary"
                    :loading="loading"
                    @click="$emit('release')"
                >确认解除</veui-button>
            </div>
        </template>
    </veui-dialog>
</template>

<script>
/**
 * @file trusteeship-dialog.vue
 * @desc 线索托管授权/解除弹窗（律师端 PC），UI 依据设计稿「托管服务授权」
 */
import {Dialog, Button} from 'veui';

// 托管授权说明插图（设计切图，托管在 BOS）
const ILLUS_IMG = 'https://lvlin-fe-saas.cdn.bcebos.com/trusteeship/trustee-illuss.png';

export default {
    name: 'TrusteeshipDialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        // 弹窗展示状态
        open: {
            type: Boolean,
            default: false
        },
        // confirm: 授权确认；release: 解除托管
        mode: {
            type: String,
            default: 'confirm'
        },
        // 超管账号名称
        platformName: {
            type: String,
            default: ''
        },
        // 按钮加载态（授权托管 / 确认解除）
        loading: {
            type: Boolean,
            default: false
        },
        // 拒绝托管按钮加载态
        rejectLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            illusImg: ILLUS_IMG
        };
    },
    computed: {
        isConfirm() {
            return this.mode === 'confirm';
        },
        // 授权确认与托管中说明文案
        desc() {
            return this.isConfirm
                ? '授权后超管可查看并跟进线索，标记线索有效性，减少商机遗漏，您仍拥有线索处置权，并可「解除授权」'
                : '解除后，超管账号将不再跟进线索，是否确认解除？';
        }
    },
    methods: {
        // 点击关闭（X / 蒙层）时触发
        onOpenChange(val) {
            if (!val) {
                this.$emit('dismiss');
            }
        }
    }
};
</script>

<style lang="less">
.trusteeship-dialog-overlay {
    .veui-dialog-box-mask {
        background-color: rgba(0, 0, 0, .3);
    }

    .veui-dialog-content {
        width: 516px;
        padding-bottom: 0;
        position: relative;
        border-radius: 6px;
    }

    .veui-dialog-content-head {
        padding: 18px 24px 6px;

        .title {
            display: flex;
            flex: 1;
            align-items: center;
            color: #000311;
            font-size: 18px;
            line-height: 18px;
            font-weight: 500;
        }
    }

    .veui-dialog-content-body {
        padding: 12px 24px 18px;
    }

    .close-btn {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 18px;
        right: 21px;
        background: url("https://lvlin-sp-saas.cdn.bcebos.com/assets/trusteeship/dialog-close-release.png") no-repeat;
        background-size: cover;
        cursor: pointer;
        z-index: 1;
        transform: translateY(-3px);
    }

    .ts-body {
        .ts-lead {
            font-size: 16px;
            color: #1e1f24;
            line-height: 16px;
        }

        .ts-strong {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #1e1f24;
        }

        .ts-desc {
            margin-top: 7px;
            font-size: 14px;
            color: #848691;
            line-height: 22px;
        }

        .ts-illus {
            display: block;
            width: 100%;
            height: auto;
            border-radius: 10px;
            margin-top: 13px;
        }
    }

    .veui-dialog-content-foot {
        padding: 4px 24px 18px;
        margin-left: auto;
        text-align: right;

        .veui-button {
            min-width: 136px;
            height: 44px;
            border-radius: 6px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            line-height: 16px;
            font-weight: 500;

            &:focus,
            &:focus-visible {
                outline: none;
                box-shadow: none;
            }
        }

        .veui-button + .veui-button {
            margin-left: 12px;
        }

        .veui-button[ui~="primary"] {
            background: #0054ff;
            border-color: #0054ff;

            &:hover,
            &:focus,
            &:active {
                background: #004ce5;
                border-color: #004ce5;
            }
        }

        .ts-btn-minor {
            background: #fff;
            border: 1px solid rgba(30, 31, 36, .2);
            color: #1e1f24;

            &:hover,
            &:focus,
            &:active {
                background: #fff;
                border-color: rgba(30, 31, 36, .2);
                color: #1e1f24;
            }
        }
    }
}

// 解除线索托管：视觉对齐代运营解除弹窗（hosting-release-dialog）
.trusteeship-dialog-overlay.is-release {
    .veui-dialog-content {
        border-radius: 8px;
    }

    .veui-dialog-content-head {
        display: flex;
        align-items: center;
    }

    .veui-dialog-content-body {
        padding: 18px 24px;
    }

    .ts-body {
        .ts-desc {
            margin-top: 0;
            font-size: 16px;
            line-height: 24px;
            color: #50525c;
        }
    }

    .veui-dialog-content-foot {
        padding: 4px 24px 18px;
        margin-left: auto;
    }

    .ts-foot {
        display: flex;
        justify-content: flex-end;

        .ts-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 0;
            height: 44px;
            padding-inline: 36px;
            border-radius: 6px;
            font-size: 16px;
            line-height: 16px;
            font-weight: 500;
            cursor: pointer;
            box-sizing: border-box;

            &:focus,
            &:focus-visible {
                outline: none;
                box-shadow: none;
            }
        }

        .ts-btn-minor {
            color: #1e1f24;
            background: #fff;
            border: 1px solid rgba(30, 31, 36, .2);

            &:hover,
            &:focus,
            &:active {
                color: #1e1f24;
                background: #fff;
                border-color: rgba(30, 31, 36, .2);
            }
        }

        .ts-btn-primary {
            color: #fff;
            background: #0054ff;
            border-color: #0054ff;

            &:hover,
            &:focus,
            &:active {
                background: #004ce5;
                border-color: #004ce5;
            }
        }
    }
}
</style>
